export default __webpack_public_path__ + "static/media/Inter-UI-Black.6594ce0f.woff2";